export enum PaymentStatus {
  successful = 'successful',
  refunded = 'refunded',
  uncaptured = 'uncaptured',
  cancelled = 'cancelled',
}

export enum OrderPaymentStatus {
  Created = 'created',
  Fulfilled = 'fulfilled',
  Failed = 'failed',
  Released = 'released',
}

export enum TransactionStatus {
  Successful = 'successful',
  Failed = 'failed',
  FailedRefund = 'failed_refund',
  Refunded = 'refunded',
  Pending = 'pending',
  Uncaptured = 'uncaptured',
}

export enum PaymentProcessor {
  Stipend = 'stipend',
  PaytronixGiftCard = 'paytronix-gift-card',
  Stripe = 'stripe',
}

// for the following status, it's correct to have multiple transaction with the same reference (id+type)
export const NonUniqueTransactionStatus = [
  TransactionStatus.Failed,
  TransactionStatus.FailedRefund,
  TransactionStatus.Refunded,
];

// for the following status, it's correct to have multiple transaction with the same reference (id+type)
export const NonRefundableStatus = [
  TransactionStatus.Failed,
  TransactionStatus.Refunded,
];

export type PaymentItemResponse = {
  id: string;
  processor: string;
  paymentAmount: number;
  amountEligibleForPointsInCents: number;
  url: string;
  status: PaymentStatus;
  paymentTime?: Date;
  metadata: PaymentItemMetadata;
};

export type PaymentItemMetadata = {
  cardType?: string;
  cardLast4?: string;
  refunded?: boolean;
  refundedAmount?: number;
};

export type PaymentTransactionRequest = {
  transactionId?: string;
  referenceId?: string;
  status?: TransactionStatus;
  includeMetadata?: boolean;
};

export type PaymentTransactionResponse = {
  transactionId: string;
  transactionStatus: TransactionStatus;
  creditApplied?: number;
  referenceId?: string;
  transactionAmount?: number;
  payments?: Array<PaymentItemResponse>;
  paymentTime?: Date;
};
